import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getTimeSheets = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/time_sheets', {
        params,
        withCredentials: true
    });
    return res;
}

export const signTimeSheet = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/time_sheets/sign',
    createObj,
    {
        withCredentials: true,
        successMessage: "ลงบันทึกเวลาเรียบร้อย"
    });
    return res;
}
